import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType, GenericColumnData } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { CreateCommanWay, ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon, ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import Modal from "components/Modal/Modal";
import { roles } from "utils/constant";
import { Button } from "@heroui/react";
import { useAuthStore } from "store/auth";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";

const VendorPayList: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [totals, setTotals] = useState<any>({});
  const [kpsTotal, setKpsTotal] = useState<any>({});
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").subtract(1, "days").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [sortStat, setSortStat] = useState<any>({});
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [billNoFilter, setBillNoFilter] = useState("");
  const [ackNoFilter, setAckNoFilter] = useState("");
  const [openAwbDropdownId, setOpenAwbDropdownId] = useState<number | null>(null); // Track which row's AWB dropdown is open

  // Multi-select state
  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const [gstTdsPaidModalOpen, setGstTdsPaidModalOpen] = useState(false);
  const [paidType, setPaidType] = useState<"gst" | "tds" | null>(null);
  const [isPaidAction, setIsPaidAction] = useState<boolean>(true); // true = mark as paid, false = mark as unpaid
  const [bulkActionModalOpen, setBulkActionModalOpen] = useState(false);
  const [bulkActionType, setBulkActionType] = useState<"disburse" | "reject" | null>(null);
  const [bulkRemark, setBulkRemark] = useState("");
  const [summaryPopupType, setSummaryPopupType] = useState<"VERIFIED" | "PROCESSED" | "BANK_RETURN" | null>(null);

  const [query, setQuery] = useState<any>({
    invoiceDate: {
      $gte: startDate ? startDate : moment().startOf("day").subtract(1, "days"),
      $lte: endDate ? moment(endDate).endOf("day") : moment().endOf("day"),
    },
  });
  const [isDataAdded, setIsDataAdded] = useState(false);
  const [branchOpt, setBranchOtp] = useState<any[]>([]);
  const [branchOptions, setBranchOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const [subbranchOptions, setSubbranchOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const [selectedSubbranch, setSelectedSubbranch] = useState<any>();

  const [selectedStatus, setSelectedStatus] = useState<any>();

  const [verifyModalOpen, setVerifyModalOpen] = useState(false);

  const [seletedPayment, setSeletedPayment] = useState<any>({});
  const [disburseModalOpen, setDisburseModalOpen] = useState(false);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [remark, setRemark] = useState("");

  const [refNo, setRefNo] = useState<any>("");
  const [paymentDate, setPaymentDate] = useState<any>("");
  const [payType, setPayType] = useState<any>({});

  useQuery(["VendorListApi"], () => ListCommanWay("/admin/vendor/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt:any[] = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.id,
            label: p.vendor_name,
          });
        });
        setBranchOptions(opt);
      }
    },
  });
  useQuery(["SubbranchListApi"], () => ListCommanWay("/admin/subbranch/list", {}, { paginate: 1000 }), {
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt:any[] = [];
        if (data?.data) {
          data?.data?.data?.forEach((d: any) => {
            opt.push({
              value: d?.id,
              label: d?.branch_name,
            });
          });
          setSubbranchOptions(opt);
        }
      }
    },
  });

  const {
    mutate: deleteVendorPayment,
    isLoading: isDeleting,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((id) => CreateCommanWay({ url: "/admin/vendorpayment/deleteMany", data: { isWarning: true, ids: [id] } }), {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        setTotals({ grand: 0 });
        UseToast("Payment Removed Successfully", "success");
        refetch();
        refetchSummary?.();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const {
    mutate: updatePayMutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Data Updated Successfully", "success");
        setTotals({ grand: 0 });
        refetch();
        refetchSummary?.();
        setDisburseModalOpen(false);
        setVerifyModalOpen(false);
        setRejectModalOpen(false);
        setGstTdsPaidModalOpen(false);
        setSelectedRows(new Set());
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  // Bulk update mutation for GST/TDS paid
  const { mutate: bulkUpdatePayMutate, isLoading: isBulkUpdating } = useMutation(
    (params: { ids: number[]; updateData: any }) =>
      UpdateCommanWay({
        url: "/admin/vendorpayment/updateBulk",
        data: {
          filter: { id: params.ids },
          data: params.updateData,
        },
      }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          UseToast("Data Updated Successfully", "success");
          setTotals({ grand: 0 });
          refetch();
          refetchSummary?.();
          setGstTdsPaidModalOpen(false);
          setBulkActionModalOpen(false);
          setBulkActionType(null);
          setBulkRemark("");
          setSelectedRows(new Set());
          setPaidType(null);
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    },
  );

  // Calculate total for selected rows
  const getSelectedTotal = (type: "gst" | "tds") => {
    let total = 0;
    tableData.forEach((row: any) => {
      if (selectedRows.has(row.id)) {
        if (type === "gst") {
          total += Number(row.cgst || 0) + Number(row.sgst || 0) + Number(row.igst || 0);
        } else {
          total += Number(row.tds || 0);
        }
      }
    });
    return total;
  };

  // Handle select all
  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      const allIds = tableData.map((row: any) => row.id);
      setSelectedRows(new Set(allIds));
    } else {
      setSelectedRows(new Set());
    }
  };

  // Handle single row select
  const handleRowSelect = (id: number, checked: boolean) => {
    const newSelected = new Set(selectedRows);
    if (checked) {
      newSelected.add(id);
    } else {
      newSelected.delete(id);
    }
    setSelectedRows(newSelected);
  };

  // Handle paid button click
  const handlePaidClick = (type: "gst" | "tds", markAsPaid: boolean = true) => {
    if (selectedRows.size === 0) {
      UseToast("Please select at least one row", "error");
      return;
    }
    setPaidType(type);
    setIsPaidAction(markAsPaid);
    setGstTdsPaidModalOpen(true);
  };

  // Handle confirm paid
  const handleConfirmPaid = () => {
    if (!paidType || selectedRows.size === 0) return;

    const ids = Array.from(selectedRows);
    const updateData = paidType === "gst" ? { gstPaid: isPaidAction } : { tdsPaid: isPaidAction };

    bulkUpdatePayMutate({ ids, updateData });
  };

  // Handle bulk disburse/reject
  const handleBulkAction = (type: "disburse" | "reject") => {
    if (selectedRows.size === 0) {
      UseToast("Please select at least one row", "error");
      return;
    }
    setBulkActionType(type);
    setBulkRemark("");
    setBulkActionModalOpen(true);
  };

  const handleConfirmBulkAction = () => {
    if (!bulkActionType || selectedRows.size === 0) return;
    const ids = Array.from(selectedRows);
    const updateData =
      bulkActionType === "disburse"
        ? { status: "PAID" }
        : { status: "REJECTED", remark: bulkRemark };
    bulkUpdatePayMutate({ ids, updateData });
  };

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_vendorpayments_report_list"],
    () => ListCommanWay("/admin/vendorpayment/list", { ...query }, { paginate: 1000, include: ["_vendor"] }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data.rows);
          setSortStat({});

          let ary = [...data.data.rows];
          let ttt = {
            base: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            utgst: 0,
            grand: 0,
            tds: 0,
            payable: 0,
            totalPaid: 0,
            remaining: 0,
          };

          let kps = {};
          ary.forEach((a) => {
            //console.log(a.base_value);
            ttt.base += Number(a.basicAmount || 0);
            ttt.cgst += Number(a.cgst) || 0;
            ttt.sgst += Number(a.sgst) || 0;
            ttt.igst += Number(a.igst) || 0;
            ttt.utgst += Number(a.utgst || 0) || 0;
            ttt.grand += Number(a.finalAmount) || 0;
            ttt.tds += Number(a.tds) || 0;
            ttt.payable += (Number(a.finalAmount) || 0) - (Number(a.tds) || 0);
            ttt.totalPaid += Number(a.totalPaid) || 0;
            ttt.remaining += ((Number(a.finalAmount) || 0) - (Number(a.tds) || 0)) - (Number(a.totalPaid) || 0);

            if (!kps[a.status]) {
              kps[a.status] = [0, 0, 0];
            }
            kps[a.status][0]++;
            kps[a.status][1] += Number(a.finalAmount) || 0;
            kps[a.status][2] += Number(a.tds) || 0;
          });
          setTotals(ttt);
          setKpsTotal(kps);
        } else {
          setTableData([]);
          setKpsTotal({});
        }
      },
      onError: (data) => {
        setTableData([]);
        setKpsTotal({});
      },
    },
  );

  useEffect(() => {
    setTotals({ grand: 0 });
    refetch();
  }, [query]);

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);
    console.log(selectedStatus);
    setQuery({
      ...(billNoFilter || ackNoFilter
        ? {} // Exclude invoiceDate if billNo or ackNo is present
        : startDate && endDate
        ? {
            invoiceDate: {
              $gte: startDate,
              $lte: moment(endDate).endOf("day"),
            },
          }
        : {}),
      vendor: branchOpt?.length > 0 ? (branchOpt.length === 1 ? branchOpt[0].value : { $in: branchOpt.map((v) => v.value) }) : undefined,
      billNo: billNoFilter ? billNoFilter : undefined,
      id: ackNoFilter ? ackNoFilter : undefined,
      subbranch: selectedSubbranch?.value,
      status: selectedStatus?.value || undefined,
    });
  };

  const __handleReset = () => {
    setBranchOtp([]);
    setSelectedSubbranch(undefined);
    setSelectedStatus(undefined);
    setBillNoFilter("");
    setAckNoFilter("");
    setQuery({});
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const { paymentPublicKey } = useAuthStore();

  // Dedicated query for Summary (independent of main table search filters, modeled after Expense Voucher)
  const {
    data: summaryApiResponse,
    isLoading: isSummaryLoading,
    refetch: refetchSummary,
  } = useQuery(
    ["admin_vendorpayment_summary_list"],
    () =>
      ListCommanWay(
        "/admin/vendorpayment/list",
        {
          $or: [
            { status: { $in: ["VERIFIED", "PROCESSED", "PROCESS", "BANK_RETURN"] } },
            { refNo: { $in: ["PROCESS", "PROCESSED", "BANK_RETURN"] } },
          ],
        },
        { paginate: 10000, include: ["_vendor"] }
      ),
    {
      keepPreviousData: true,
    }
  );

  // Group summaries by vendor for VERIFIED and PROCESSED (along with BANK_RETURN)
  const { verifiedSummary, processedSummary, bankReturnSummary } = React.useMemo(() => {
    const verifiedMap: Record<string, { name: string; count: number; payableAmount: number; finalAmount: number }> = {};
    const processedMap: Record<string, { name: string; count: number; payableAmount: number; finalAmount: number }> = {};
    const bankReturnMap: Record<string, { name: string; count: number; payableAmount: number; finalAmount: number }> = {};

    const summaryRows: any[] = summaryApiResponse?.data?.rows || summaryApiResponse?.data?.data || [];

    summaryRows.forEach((row: any) => {
      const vendorName = row._vendor?.vendor_name || row._vendor?.name || row.vendorName || "Unknown Vendor";
      const vendorKey = String(row.vendor || row._vendor?.id || vendorName).trim();
      const finalAmt = Number(row.finalAmount) || 0;
      const tdsAmt = Number(row.tds) || 0;
      const totalPaid = Number(row.totalPaid) || 0;
      const payableAmt = Math.max(0, finalAmt - tdsAmt - totalPaid);

      const statusUpper = String(row.status || "").trim().toUpperCase();
      const refNoUpper = String(row.refNo || "").trim().toUpperCase();

      const isBankReturn = statusUpper === "BANK_RETURN" || refNoUpper === "BANK_RETURN";
      const isProcessed =
        !isBankReturn &&
        (refNoUpper === "PROCESS" ||
          refNoUpper === "PROCESSED" ||
          statusUpper === "PROCESSED" ||
          statusUpper === "PROCESS");

      if (isBankReturn) {
        if (!bankReturnMap[vendorKey]) {
          bankReturnMap[vendorKey] = { name: vendorName, count: 0, payableAmount: 0, finalAmount: 0 };
        }
        bankReturnMap[vendorKey].count += 1;
        bankReturnMap[vendorKey].payableAmount += payableAmt || (finalAmt - tdsAmt);
        bankReturnMap[vendorKey].finalAmount += finalAmt;
      } else if (isProcessed) {
        if (!processedMap[vendorKey]) {
          processedMap[vendorKey] = { name: vendorName, count: 0, payableAmount: 0, finalAmount: 0 };
        }
        processedMap[vendorKey].count += 1;
        processedMap[vendorKey].payableAmount += payableAmt || (finalAmt - tdsAmt);
        processedMap[vendorKey].finalAmount += finalAmt;
      } else if (statusUpper === "VERIFIED") {
        if (!verifiedMap[vendorKey]) {
          verifiedMap[vendorKey] = { name: vendorName, count: 0, payableAmount: 0, finalAmount: 0 };
        }
        verifiedMap[vendorKey].count += 1;
        verifiedMap[vendorKey].payableAmount += payableAmt || (finalAmt - tdsAmt);
        verifiedMap[vendorKey].finalAmount += finalAmt;
      }
    });

    return {
      verifiedSummary: verifiedMap,
      processedSummary: processedMap,
      bankReturnSummary: bankReturnMap,
    };
  }, [summaryApiResponse]);

  const verifiedTotalCount = React.useMemo(
    () => Object.values(verifiedSummary).reduce((sum, item) => sum + item.count, 0),
    [verifiedSummary]
  );
  const verifiedTotalAmount = React.useMemo(
    () => Object.values(verifiedSummary).reduce((sum, item) => sum + item.payableAmount, 0),
    [verifiedSummary]
  );

  const processedTotalCount = React.useMemo(
    () => Object.values(processedSummary).reduce((sum, item) => sum + item.count, 0),
    [processedSummary]
  );
  const processedTotalAmount = React.useMemo(
    () => Object.values(processedSummary).reduce((sum, item) => sum + item.payableAmount, 0),
    [processedSummary]
  );

  const bankReturnTotalCount = React.useMemo(
    () => Object.values(bankReturnSummary).reduce((sum, item) => sum + item.count, 0),
    [bankReturnSummary]
  );
  const bankReturnTotalAmount = React.useMemo(
    () => Object.values(bankReturnSummary).reduce((sum, item) => sum + item.payableAmount, 0),
    [bankReturnSummary]
  );

  const activeSummaryMap =
    summaryPopupType === "VERIFIED"
      ? verifiedSummary
      : summaryPopupType === "PROCESSED"
      ? processedSummary
      : summaryPopupType === "BANK_RETURN"
      ? bankReturnSummary
      : {};

  const activeSummaryEntries = React.useMemo(() => {
    return Object.entries(activeSummaryMap).sort((a: any, b: any) => b[1].payableAmount - a[1].payableAmount);
  }, [activeSummaryMap]);

  const activeSummaryTotalCount = React.useMemo(() => {
    return Object.values(activeSummaryMap).reduce((sum: number, item: any) => sum + (item.count || 0), 0);
  }, [activeSummaryMap]);

  const activeSummaryTotalAmount = React.useMemo(() => {
    return Object.values(activeSummaryMap).reduce((sum: number, item: any) => sum + (item.payableAmount || 0), 0);
  }, [activeSummaryMap]);
  const tableRef = useRef(null);

  const encryptWithRSA = async (data: object): Promise<string | false> => {
    if (!paymentPublicKey) return false;
    try {
      let pemBody = paymentPublicKey
        .replace(/-----BEGIN (RSA )?PUBLIC KEY-----/g, "")
        .replace(/-----END (RSA )?PUBLIC KEY-----/g, "")
        .replace(/\\n/g, "")
        .replace(/\s/g, "");

      const binaryDer = Uint8Array.from(atob(pemBody), (c) => c.charCodeAt(0));

      const cryptoKey = await crypto.subtle.importKey(
        "spki",
        binaryDer.buffer,
        { name: "RSA-OAEP", hash: "SHA-256" },
        false,
        ["encrypt"],
      );

      const encoded = new TextEncoder().encode(JSON.stringify(data));
      const encrypted = await crypto.subtle.encrypt({ name: "RSA-OAEP" }, cryptoKey, encoded);

      const bytes = new Uint8Array(encrypted);
      let binary = "";
      for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    } catch (e) {
      console.error("RSA-OAEP encryption failed:", e);
      return false;
    }
  };

  const handleBulkPayment = async () => {
    if (!paymentPublicKey) {
      UseToast("Payment key not available. Please re-login.", "error");
      return;
    }
    if (selectedRows.size === 0) {
      UseToast("Please select at least one row.", "error");
      return;
    }

    const selectedData = tableData.filter((row: any) => selectedRows.has(row.id));
    const getDebitAccountKey = (row: any) => {
      const debitAcc = row?._vendor?.debitAcc;
      if (debitAcc && typeof debitAcc === "object") {
        return debitAcc.value ?? debitAcc.id ?? "";
      }
      return debitAcc == null ? "" : String(debitAcc).trim();
    };
    const selectedDebitAccounts = selectedData.map(getDebitAccountKey);
    const requiresDebitAccountSelection = selectedDebitAccounts.some((account) => !account);
    const hasMixedDebitAccounts = requiresDebitAccountSelection && selectedDebitAccounts.some((account) => account);

    // Build HTML for editable amounts table
    let totalPayableSum = 0;
    let totalPayAmtSum = 0;

    const formatAmtNoSymbol = (val: number) => {
      return (val || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    let tableHtml = '<div style="max-height:300px;overflow-y:auto;"><table style="width:100%;border-collapse:collapse;font-size:13px;">';
    tableHtml += '<tr style="background:#f3f4f6;"><th style="padding:6px;border:1px solid #e5e7eb;">Vendor</th><th style="padding:6px;border:1px solid #e5e7eb;">Payable</th><th style="padding:6px;border:1px solid #e5e7eb;">Pay Amount</th></tr>';
    selectedData.forEach((r: any) => {
      const payableNum = (Number(r.finalAmount) || 0) - (Number(r.tds) || 0) - (Number(r.totalPaid) || 0);
      totalPayableSum += payableNum;
      totalPayAmtSum += payableNum;
      const payable = payableNum.toFixed(2);
      tableHtml += `<tr><td style="padding:4px 6px;border:1px solid #e5e7eb;">${r._vendor?.vendor_name || '-'}</td><td style="padding:4px 6px;border:1px solid #e5e7eb;text-align:right;">₹${payable}</td><td style="padding:4px 6px;border:1px solid #e5e7eb;"><input type="number" id="amt_${r.id}" value="${payable}" max="${payable}" min="0" step="0.01" style="width:100px;padding:4px;border:1px solid #d1d5db;border-radius:4px;text-align:right;" /></td></tr>`;
    });
    tableHtml += `<tr style="background:#f9fafb;font-weight:700;font-size:15px;"><td style="padding:8px 6px;border:1px solid #e5e7eb;">Total</td><td style="padding:8px 6px;border:1px solid #e5e7eb;text-align:right;">${formatAmtNoSymbol(totalPayableSum)}</td><td style="padding:8px 6px;border:1px solid #e5e7eb;text-align:right;color:#059669;" id="swal_totalPayAmt">${formatAmtNoSymbol(totalPayAmtSum)}</td></tr>`;
    tableHtml += '</table></div>';
    if (requiresDebitAccountSelection) {
      if (hasMixedDebitAccounts) {
        tableHtml += '<div style="margin-top:12px;padding:8px;color:#92400e;background:#fef3c7;border:1px solid #fcd34d;border-radius:6px;font-size:13px;">Some selected vendors do not have a debit account. Please select the debit account to use.</div>';
      }
      tableHtml += `<div style="margin-top:12px;"><label style="font-weight:600;font-size:13px;">Debit Account:</label><select id="swal_debitAccount" style="width:100%;padding:8px;border:1px solid #d1d5db;border-radius:6px;margin-top:4px;">
      <option value="">Select Branch</option>
      ${GenericColumnData?.user?.tableColumnData?.find((d: any) => d.key === "personalData.debitAcc")?.options.map((option: any) => {
        return `<option value="${option.value}">${option.label}</option>`;
      })}
      </select></div>`;
    }

    const { isConfirmed } = await Swal.fire({
      title: "Bulk Payment",
      html: tableHtml,
      width: 550,
      showCancelButton: true,
      confirmButtonText: "Request OTP",
      didOpen: () => {
        const updateTotalPayAmt = () => {
          let currentSum = 0;
          selectedData.forEach((r: any) => {
            const input = document.getElementById(`amt_${r.id}`) as HTMLInputElement;
            if (input) {
              const val = parseFloat(input.value);
              if (!isNaN(val)) currentSum += val;
            }
          });
          const totalEl = document.getElementById("swal_totalPayAmt");
          if (totalEl) {
            totalEl.innerText = formatAmtNoSymbol(currentSum);
          }
        };
        selectedData.forEach((r: any) => {
          const input = document.getElementById(`amt_${r.id}`);
          if (input) {
            input.addEventListener("input", updateTotalPayAmt);
          }
        });
      },
      preConfirm: () => {
        const debitAccount = (document.getElementById("swal_debitAccount") as HTMLSelectElement)?.value;
        if (requiresDebitAccountSelection && !debitAccount) {
          Swal.showValidationMessage("Please select a branch");
          return false;
        }
        // Validate amounts
        for (const r of selectedData) {
          const maxPayable = (Number(r.finalAmount) || 0) - (Number(r.tds) || 0) - (Number(r.totalPaid) || 0);
          const input = document.getElementById(`amt_${r.id}`) as HTMLInputElement;
          const amt = Number(input?.value);
          if (isNaN(amt) || amt <= 0) {
            Swal.showValidationMessage(`Invalid amount for ${r._vendor?.vendor_name}`);
            return false;
          }
          if (amt > maxPayable) {
            Swal.showValidationMessage(`Amount for ${r._vendor?.vendor_name} cannot exceed ₹${maxPayable.toFixed(2)}`);
            return false;
          }
        }
        return true;
      },
    });

    if (!isConfirmed) return;

    // Collect values after confirm
    const selectedDebitAccount = (document.getElementById("swal_debitAccount") as HTMLSelectElement)?.value;
    const debitAccountKey = Number(selectedDebitAccount || selectedDebitAccounts[0]);
    const ids: number[] = [];
    const amounts: Record<string, number> = {};
    selectedData.forEach((r: any) => {
      const input = document.getElementById(`amt_${r.id}`) as HTMLInputElement;
      ids.push(r.id);
      amounts[String(r.id)] = Number(input?.value);
    });

    // Encrypt debitAccountKey + paymentType
    const encryptedPayload = await encryptWithRSA({ debitAccountKey, paymentType: "VENDOR" });
    if (!encryptedPayload) {
      UseToast("Encryption failed. Please re-login.", "error");
      return;
    }

    try {
      const otpRes: any = await CreateCommanWay({
        url: "/admin/payment/request-otp",
        data: { ids, amounts, encryptedPayload },
      });

      if (otpRes?.status !== "SUCCESS") {
        UseToast(otpRes?.message || "Failed to request OTP", "error");
        return;
      }

      const requestId = otpRes?.data?.requestId;

      // Ask for OTP
      const { value: otp } = await Swal.fire({
        title: "Enter OTP",
        input: "text",
        inputPlaceholder: "Enter 6-digit OTP",
        showCancelButton: true,
        confirmButtonText: "Release Payment",
        inputValidator: (value) => {
          if (!value) return "Please enter OTP";
          if (value.length !== 6) return "OTP must be 6 digits";
        },
      });

      if (!otp) return;

      // Encrypt OTP payload and call release
      const encryptedRelease = await encryptWithRSA({ requestId, otp });
      if (!encryptedRelease) {
        UseToast("Encryption failed.", "error");
        return;
      }

      const releaseRes: any = await CreateCommanWay({
        url: "/admin/payment/release",
        data: { payload: encryptedRelease },
      });

      if (releaseRes?.status === "SUCCESS") {
        UseToast("Payment released successfully!", "success");
        setSelectedRows(new Set());
        refetch();
        refetchSummary?.();
      } else {
        UseToast(releaseRes?.message || "Payment release failed", "error");
      }
    } catch (err: any) {
      UseToast(typeof err === "string" ? err : err?.message || "Something went wrong", "error");
    }
  };

  // Payment Advice - frontend only HTML generation
  const handlePaymentAdvice = () => {
    if (selectedRows.size === 0) {
      UseToast("Please select at least one payment", "error");
      return;
    }

    const selectedData = tableData.filter((row: any) => selectedRows.has(row.id));

    // Check if all selected belong to the same vendor
    const vendorIds = new Set(selectedData.map((r: any) => r.vendor));
    if (vendorIds.size > 1) {
      UseToast("Payment Advice can only be generated for a single vendor. Selected payments belong to multiple vendors.", "error");
      return;
    }

    const vendorName = selectedData[0]?._vendor?.vendor_name || "-";
    const vendorGst = selectedData[0]?._vendor?.gstno_client_supplier || "-";
    let vendorAddress = selectedData[0]?._vendor?.office_address || selectedData[0]?._vendor?.address || "-";
    if (vendorAddress !== "-" && selectedData[0]?._vendor?.pin_code && !vendorAddress.includes(selectedData[0]?._vendor?.pin_code)) {
      vendorAddress += ` - ${selectedData[0]?._vendor?.pin_code}`;
    }
    const rawAccountNo = (selectedData[0]?._vendor?.account_no || selectedData[0]?._vendor?.bankAccNo || selectedData[0]?._vendor?.bank_acc_no || "").trim();
    const maskedBankAcc = rawAccountNo ? (rawAccountNo.length > 4 ? `**** *** ${rawAccountNo.slice(-4)}` : rawAccountNo) : "-";
    const vendorIfsc = selectedData[0]?._vendor?.ifsc || selectedData[0]?._vendor?.bankIfsc || selectedData[0]?._vendor?.bank_ifsc || "-";
    const companyGst = selectedData[0]?.company_gst_no || selectedData[0]?._vendor?.company_gst_no || "24AALCA0600L1Z0";

    const parseTransactions = (txns: any) => {
      if (!txns) return [];
      let parsed = txns;
      if (typeof parsed === "string") {
        try {
          while (typeof parsed === "string") parsed = JSON.parse(parsed);
        } catch {
          return [];
        }
      }
      return Array.isArray(parsed) ? parsed : [];
    };

    const isStatusProcessed = (st: any, ref?: any) => {
      const s = String(st || "").trim().toUpperCase();
      const r = String(ref || "").trim().toUpperCase();
      return s === "PROCESSED" || s === "PROCESS" || r === "PROCESS" || r === "PROCESSED";
    };

    const getSlipStatus = (st: any, ref?: any) => {
      if (isStatusProcessed(st, ref)) {
        return "PROCESSED";
      }
      return st || "-";
    };

    // Calculate totals (strictly per invoice to avoid duplicate summing)
    let totalBasic = 0, totalCgst = 0, totalSgst = 0, totalIgst = 0, totalInvoice = 0, totalTds = 0, totalPayable = 0, totalPaid = 0, totalRemaining = 0;
    selectedData.forEach((r: any) => {
      const basic = Number(r.basicAmount) || 0;
      const cgst = Number(r.cgst) || 0;
      const sgst = Number(r.sgst) || 0;
      const igst = Number(r.igst) || 0;
      const finalAmt = Number(r.finalAmount) || 0;
      const tds = Number(r.tds) || 0;
      const payable = finalAmt - tds;

      const txns = parseTransactions(r.transactions);
      const isProcessed = isStatusProcessed(r.status, r.refNo);
      let paid = 0;
      if (txns.length > 0) {
        paid = txns.reduce((sum: number, t: any) => sum + (Number(t.amount) || 0), 0);
      } else {
        paid = Number(r.totalPaid) || 0;
        if (paid === 0 && isProcessed) {
          paid = payable;
        }
      }
      const remaining = Math.max(0, payable - paid);

      totalBasic += basic;
      totalCgst += cgst;
      totalSgst += sgst;
      totalIgst += igst;
      totalInvoice += finalAmt;
      totalTds += tds;
      totalPayable += payable;
      totalPaid += paid;
      totalRemaining += remaining;
    });

    const adviceDate = moment().format("DD/MM/YYYY");

    let srNo = 1;
    const tableRowsHtml = selectedData.map((r: any) => {
      const txns = parseTransactions(r.transactions);
      const invoiceDateStr = r.invoiceDate ? moment(r.invoiceDate, ["DD-MM-YYYY HH:mm:ss", "YYYY-MM-DD HH:mm:ss"]).format("DD/MM/YYYY") : '-';
      const basicAmt = (Number(r.basicAmount) || 0).toFixed(2);
      const cgstAmt = (Number(r.cgst) || 0).toFixed(2);
      const sgstAmt = (Number(r.sgst) || 0).toFixed(2);
      const igstAmt = (Number(r.igst) || 0).toFixed(2);
      const finalAmt = (Number(r.finalAmount) || 0).toFixed(2);
      const tdsAmt = (Number(r.tds) || 0).toFixed(2);
      const payableAmt = ((Number(r.finalAmount) || 0) - (Number(r.tds) || 0)).toFixed(2);
      const isRowProcessed = isStatusProcessed(r.status, r.refNo);

      let rowPaidAmt = Number(r.totalPaid) || 0;
      if (rowPaidAmt === 0 && isRowProcessed && txns.length === 0) {
        rowPaidAmt = Number(payableAmt) || 0;
      }
      const remainingAmt = Math.max(
        0,
        (Number(payableAmt) || 0) - (txns.length > 0 ? txns.reduce((s: number, t: any) => s + (Number(t.amount) || 0), 0) : rowPaidAmt)
      ).toFixed(2);

      if (txns.length === 0) {
        const payDateStr = r.paymentDate && r.paymentDate !== "Invalid Date"
          ? moment(r.paymentDate, ["DD-MM-YYYY HH:mm:ss", "YYYY-MM-DD HH:mm:ss"]).format("DD/MM/YYYY")
          : '-';
        return `
        <tr>
          <td class="text-center">${srNo++}</td>
          <td class="text-center">${r.billNo || '-'}</td>
          <td class="text-center">${invoiceDateStr}</td>
          <td class="text-right">${basicAmt}</td>
          <td class="text-right">${cgstAmt}</td>
          <td class="text-right">${sgstAmt}</td>
          <td class="text-right">${igstAmt}</td>
          <td class="text-right">${finalAmt}</td>
          <td class="text-right">${tdsAmt}</td>
          <td class="text-right">${payableAmt}</td>
          <td class="text-right">${rowPaidAmt.toFixed(2)}</td>
          <td class="text-right">${remainingAmt}</td>
          <td class="text-center">${getSlipStatus(r.status, r.refNo)}</td>
          <td class="text-center">${r.batchNo || r.batch_no || '-'}</td>
          <td class="text-center">${payDateStr}</td>
        </tr>`;
      }

      if (txns.length === 1) {
        const t = txns[0];
        const tDate = t.date || r.paymentDate;
        const payDateStr = tDate && tDate !== "Invalid Date"
          ? moment(tDate, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", "YYYY-MM-DD", "DD-MM-YYYY"]).format("DD/MM/YYYY")
          : '-';
        let singlePaid = Number(t.amount !== undefined ? t.amount : r.totalPaid) || 0;
        if (singlePaid === 0 && (isStatusProcessed(t.status) || isRowProcessed)) {
          singlePaid = Number(payableAmt) || 0;
        }
        const paidAmt = singlePaid.toFixed(2);
        const singleRemaining = Math.max(0, (Number(payableAmt) || 0) - singlePaid).toFixed(2);
        return `
        <tr>
          <td class="text-center">${srNo++}</td>
          <td class="text-center">${r.billNo || '-'}</td>
          <td class="text-center">${invoiceDateStr}</td>
          <td class="text-right">${basicAmt}</td>
          <td class="text-right">${cgstAmt}</td>
          <td class="text-right">${sgstAmt}</td>
          <td class="text-right">${igstAmt}</td>
          <td class="text-right">${finalAmt}</td>
          <td class="text-right">${tdsAmt}</td>
          <td class="text-right">${payableAmt}</td>
          <td class="text-right">${paidAmt}</td>
          <td class="text-right">${singleRemaining}</td>
          <td class="text-center">${getSlipStatus(t.status || r.status, t.batchNo ? undefined : r.refNo)}</td>
          <td class="text-center">${t.batchNo || r.batchNo || '-'}</td>
          <td class="text-center">${payDateStr}</td>
        </tr>`;
      }

      // Multiple transactions: Use rowspan for invoice-level columns so invoice amounts appear once
      const rowSpan = txns.length;
      return txns.map((t: any, idx: number) => {
        const tDate = t.date || r.paymentDate;
        const payDateStr = tDate && tDate !== "Invalid Date"
          ? moment(tDate, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", "YYYY-MM-DD", "DD-MM-YYYY"]).format("DD/MM/YYYY")
          : '-';
        const paidAmt = (Number(t.amount) || 0).toFixed(2);

        if (idx === 0) {
          return `
        <tr>
          <td rowspan="${rowSpan}" class="text-center">${srNo++}</td>
          <td rowspan="${rowSpan}" class="text-center">${r.billNo || '-'}</td>
          <td rowspan="${rowSpan}" class="text-center">${invoiceDateStr}</td>
          <td rowspan="${rowSpan}" class="text-right">${basicAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${cgstAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${sgstAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${igstAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${finalAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${tdsAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${payableAmt}</td>
          <td class="text-right">${paidAmt}</td>
          <td rowspan="${rowSpan}" class="text-right">${remainingAmt}</td>
          <td class="text-center">${getSlipStatus(t.status || r.status, t.batchNo ? undefined : r.refNo)}</td>
          <td class="text-center">${t.batchNo || r.batchNo || '-'}</td>
          <td class="text-center">${payDateStr}</td>
        </tr>`;
        }

        return `
        <tr>
          <td class="text-right">${paidAmt}</td>
          <td class="text-center">${getSlipStatus(t.status || r.status, t.batchNo ? undefined : r.refNo)}</td>
          <td class="text-center">${t.batchNo || r.batchNo || '-'}</td>
          <td class="text-center">${payDateStr}</td>
        </tr>`;
      }).join('');
    }).join('');

    const html = `
<!DOCTYPE html>
<html>
<head>
  <title>Payment Advice - ${vendorName}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Segoe UI', Arial, sans-serif; padding: 30px; color: #333; }
    .container { max-width: 1100px; margin: 0 auto; border: 2px solid #333; padding: 30px; }
    .header { display: flex; align-items: center; border-bottom: 2px solid #333; padding-bottom: 15px; margin-bottom: 20px; position: relative; }
    .header img { height: 50px; position: absolute; left: 0; }
    .header .header-text { flex: 1; text-align: center; }
    .header h1 { font-size: 22px; font-weight: bold; color: #1a1a1a; }
    .header h2 { font-size: 16px; color: #555; margin-top: 5px; }
    .title { text-align: center; font-size: 18px; font-weight: bold; margin: 15px 0; text-decoration: underline; }
    .info-section { display: flex; justify-content: space-between; margin-bottom: 20px; font-size: 13px; }
    .info-section .left, .info-section .right { width: 48%; }
    .info-section p { margin: 4px 0; }
    .info-section .label { font-weight: 600; display: inline-block; min-width: 100px; }
    table { width: 100%; border-collapse: collapse; margin: 15px 0; font-size: 11px; }
    th { background: #f0f0f0; border: 1px solid #333; padding: 5px 6px; text-align: center; font-weight: 600; }
    td { border: 1px solid #333; padding: 4px 6px; }
    .text-right { text-align: right; }
    .text-center { text-align: center; }
    .total-row { font-weight: bold; background: #f9f9f9; }
    .footer { margin-top: 20px; display: flex; justify-content: space-between; align-items: flex-end; font-size: 11px; }
    .footer .note-block { color: #666; max-width: 350px; }
    .footer .note-block p { margin: 3px 0; }
    .footer .sign-block { text-align: center; display: flex; flex-direction: column; align-items: center; }
    .footer .sign-block .images { display: flex; align-items: center; gap: 5px; }
    .footer .sign-block .stamp { height: 70px; }
    .footer .sign-block .sign { height: 45px; }
    .footer .sign-block .line { border-top: 1px solid #333; padding-top: 5px; margin-top: 5px; width: 100%; }
    .note { margin-top: 20px; font-size: 11px; color: #666; border-top: 1px dashed #999; padding-top: 10px; }
    @media print {
      body { padding: 10px; }
      .container { border: none; padding: 10px; }
      .no-print { display: none; }
    }
    .print-btn { text-align: center; margin-bottom: 20px; display: flex; gap: 10px; justify-content: center; }
    .print-btn button { padding: 10px 30px; font-size: 14px; background: #2563eb; color: white; border: none; border-radius: 5px; cursor: pointer; }
    .print-btn button:hover { background: #1d4ed8; }
    .print-btn button.pdf-btn { background: #dc2626; }
    .print-btn button.pdf-btn:hover { background: #b91c1c; }
    .amount-words { font-size: 13px; margin: 10px 0; font-style: italic; }
  </style>
</head>
<body>
  <div class="print-btn no-print">
    <button onclick="window.print()">Print Payment Advice</button>
    <button class="pdf-btn" onclick="downloadPdf()">Download PDF</button>
  </div>
  <div class="container">
    <div class="header">
      <img src="/logo.jpg" alt="Airfield Express" />
      <div class="header-text">
        <h1>AIRFIELD EXPRESS PRIVATE LIMITED</h1>
        <h2>Payment Advice</h2>
      </div>
    </div>

    <div class="info-section">
      <div class="left">
        <p><span class="label">Beneficiary:</span> ${vendorName}</p>
        <p><span class="label">GSTIN:</span> ${vendorGst}</p>
        <p><span class="label">Address:</span> ${vendorAddress}</p>
        <p><span class="label">Bank Acc No:</span> ${maskedBankAcc}</p>
        <p><span class="label">IFSC Code:</span> ${vendorIfsc}</p>
      </div>
      <div class="right" style="text-align: right;">
        <p><span class="label">Date:</span> ${adviceDate}</p>
        <p><span class="label">No. of Invoices:</span> ${selectedData.length}</p>
        <p><span class="label">CIN:</span> U64120DL2012PTC243510</p>
        <p><span class="label">GSTIN:</span> ${companyGst}</p>
      </div>
    </div>

    <div class="title">PAYMENT ADVICE</div>

    <table>
      <thead>
        <tr>
          <th>Sr.</th>
          <th>Invoice No</th>
          <th>Invoice Date</th>
          <th>Basic Amt (₹)</th>
          <th>CGST (₹)</th>
          <th>SGST (₹)</th>
          <th>IGST (₹)</th>
          <th>Invoice Amt (₹)</th>
          <th>TDS (₹)</th>
          <th>Payable (₹)</th>
          <th>Paid (₹)</th>
          <th>Remaining (₹)</th>
          <th>Status</th>
          <th>Batch no</th>
          <th>Pay Date</th>
        </tr>
      </thead>
      <tbody>
        ${tableRowsHtml}
        <tr class="total-row">
          <td colspan="3" class="text-center">TOTAL</td>
          <td class="text-right">${totalBasic.toFixed(2)}</td>
          <td class="text-right">${totalCgst.toFixed(2)}</td>
          <td class="text-right">${totalSgst.toFixed(2)}</td>
          <td class="text-right">${totalIgst.toFixed(2)}</td>
          <td class="text-right">${totalInvoice.toFixed(2)}</td>
          <td class="text-right">${totalTds.toFixed(2)}</td>
          <td class="text-right">${totalPayable.toFixed(2)}</td>
          <td class="text-right">${totalPaid.toFixed(2)}</td>
          <td class="text-right">${totalRemaining.toFixed(2)}</td>
          <td colspan="3"></td>
        </tr>
      </tbody>
    </table>

    <p class="amount-words"><strong>Total Payable: ₹ ${totalPayable.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} | Paid: ₹ ${totalPaid.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} | Remaining: ₹ ${totalRemaining.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></p>

    <div class="footer">
      <div class="note-block">
        <p>This is a system-generated Payment Advice.</p>
        <p>For any discrepancies, please contact accounts department immediately. Email: purchase@airfield.co.in</p>
      </div>
      <div class="sign-block">
        <div class="images">
          <img class="stamp" src="/images/stamp1.png" alt="Company Stamp" />
          <img class="sign" src="/images/sanjiv_sign.png" alt="Signature" />
        </div>
        <div class="line">Authorized Signatory</div>
      </div>
    </div>
  </div>
  <script>
    function downloadPdf() {
      var el = document.querySelector('.container');
      var opt = {
        margin: 10,
        filename: 'Payment_Advice_${vendorName.replace(/[^a-zA-Z0-9]/g, '_')}.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
      };
      html2pdf().set(opt).from(el).save();
    }
  </script>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
</body>
</html>`;

    // Open in new window
    const newWindow = window.open("", "_blank");
    if (newWindow) {
      newWindow.document.write(html);
      newWindow.document.close();
    }
  };

  const exportToExcel = () => {
    const table:any = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }

    const rows = tableClone.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      const dateCell = row.cells[1]; // Second column is at index 1
      dateCell.innerText = moment(dateCell.innerText, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    console.log(tableClone);

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Vendor Payment Report.xlsx");
  };

  const exportTdsReport = () => {
    // Create TDS report data
    const tdsData = tableData.map((r: any) => {
      const invoiceDate = moment(r.invoiceDate, "DD-MM-YYYY HH:mm:ss");
      const recvDate = moment(r.recvDate, "DD-MM-YYYY HH:mm:ss");
      const noOfMonths = Math.max(0, recvDate.diff(invoiceDate, "months"));
      const tdsRate = Number(r._vendor?.tds) || 0;
      const tdsAmount = Number(r.tds) || 0;
      const interest = Number((tdsAmount * 0.015 * noOfMonths).toFixed(2));
      const panNo = r._vendor?.gst_type || "";
      const fourthLetterOfPan = panNo.length >= 4 ? panNo.charAt(3).toUpperCase() : "";
      const tdsApplicability = tdsRate > 0 ? "Yes" : "No";
      const basicAmount = Number(r.basicAmount) || 0;

      return {
        "Date": invoiceDate.format("DD/MM/YYYY"),
        "Invoice no.": r.billNo || "",
        "Particulars": r._vendor?.vendor_name || "",
        "GSTIN/UIN": r._vendor?.gstno_client_supplier || "",
        "PAN No.": panNo,
        "pan 4 later": fourthLetterOfPan,
        "TDS Applicability": tdsApplicability,
        "Tax Rate": tdsRate,
        "Basic Amount": basicAmount,
        "TDS Amount": tdsAmount,
        "Interest": interest,
        "No. of Months": noOfMonths,
      };
    });

    // Add empty row and total row placeholder
    tdsData.push({
      "Date": "",
      "Invoice no.": "",
      "Particulars": "",
      "GSTIN/UIN": "",
      "PAN No.": "",
      "pan 4 later": "",
      "TDS Applicability": "",
      "Tax Rate": "",
      "Basic Amount": "",
      "TDS Amount": "",
      "Interest": "",
      "No. of Months": "",
    });

    tdsData.push({
      "Date": "",
      "Invoice no.": "",
      "Particulars": "TOTAL",
      "GSTIN/UIN": "",
      "PAN No.": "",
      "pan 4 later": "",
      "TDS Applicability": "",
      "Tax Rate": "",
      "Basic Amount": 0,
      "TDS Amount": 0,
      "Interest": 0,
      "No. of Months": "",
    });

    const ws = utils.json_to_sheet(tdsData);
    
    // Add SUM formulas for total row
    // Row 1 is header, data starts at row 2, total row is at dataLength + 3 (including empty row)
    const totalRowNum = tableData.length + 3;
    const dataEndRow = tableData.length + 1;
    
    // Column I = Basic Amount, J = TDS Amount, K = Interest
    ws[`I${totalRowNum}`] = { t: "n", f: `SUM(I2:I${dataEndRow})` };
    ws[`J${totalRowNum}`] = { t: "n", f: `SUM(J2:J${dataEndRow})` };
    ws[`K${totalRowNum}`] = { t: "n", f: `SUM(K2:K${dataEndRow})` };

    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "TDS Report");

    const wbout = write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, `TDS Report ${moment().format("DD-MM-YYYY")}.xlsx`);
  };

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key: any, info: any) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a: any, b: any) => {
      let valueA: any;
      let valueB: any;

      if (key === "payable" || key === "payableAmount") {
        valueA = (Number(a.finalAmount) || 0) - (Number(a.tds) || 0);
        valueB = (Number(b.finalAmount) || 0) - (Number(b.tds) || 0);
      } else {
        valueA = key.split(".").reduce((obj: any, k: string) => (obj ? obj[k] : undefined), a);
        valueB = key.split(".").reduce((obj: any, k: string) => (obj ? obj[k] : undefined), b);
      }

      // Convert numeric values/strings to numbers for proper numeric sorting
      const numA = Number(valueA);
      const numB = Number(valueB);
      if (
        !isNaN(numA) &&
        !isNaN(numB) &&
        valueA !== "" &&
        valueB !== "" &&
        valueA !== null &&
        valueB !== null &&
        valueA !== undefined &&
        valueB !== undefined
      ) {
        return order === "asc" ? numA - numB : numB - numA;
      }

      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <>
      {rejectModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1">
              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Reject Remark</label>
                <input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-52 p-2.5`}
                  placeholder="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-red-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    updatePayMutate({
                      url: "/admin/vendorpayment/update/" + seletedPayment?.id,
                      data: {
                        status: "REJECTED",
                        remark: remark,
                      },
                    });
                  }}
                >
                  Reject
                </button>
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    setRejectModalOpen(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {disburseModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-full">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col gap-4 bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 w-full max-w-sm">
              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">
                  Payment Date:{" "}
                  {seletedPayment.paymentDate ? moment(seletedPayment.paymentDate, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY") : "-"}
                </label>
                {/*<input
                  type="date"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  value={paymentDate}
                  onChange={(e) => setPaymentDate(e.target.value)}
                  disabled={true}
                />*/}
              </div>

              <div className={`items-center gap-2`}>
                <label className="mb-2 text-sm font- text-gray-900">Payment Method: {seletedPayment.payType}</label>
                {/*<Select
                  className={`${false ? "bg-gray-300" : ""} w-full bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                  options={GenericColumnData?.vendorpayment?.tableColumnData?.find((d: any) => d.key === "payType")?.options || []}
                  onChange={(e) => {
                    setPayType(e);
                  }}
                  value={payType}
                  isClearable={true}
                />*/}
              </div>

              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Payment Ref. No: {seletedPayment.refNo}</label>
                {/*<input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  placeholder="Payment Ref. No"
                  value={refNo}
                  onChange={(e) => setRefNo(e.target.value)}
                />*/}
              </div>

              <div className="">
                <label className="block mb-0.5 text-sm font-medium text-gray-900">Remark: {seletedPayment.remark}</label>
                {/*<input
                  type="text"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                  placeholder="Remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />*/}
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-blue-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    /*if (!paymentDate || !refNo || !payType?.value) {
                      window.alert("Select Valid Value");
                      return;
                    }*/
                    updatePayMutate({
                      url: "/admin/vendorpayment/update/" + seletedPayment?.id,
                      data: {
                        status: "PAID",
                        /*paymentDate: paymentDate,
                        payType: payType?.value || "",
                        refNo: refNo || "",
                        remark: remark || "",*/
                      },
                    });
                  }}
                >
                  Disburse
                </button>
                <button
                  className="mt-4 self-center rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
                  onClick={() => {
                    setDisburseModalOpen(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* GST/TDS Paid Confirmation Modal */}
      {gstTdsPaidModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 min-w-[300px]">
              <h2 className="text-lg font-semibold mb-4 text-center">
                {isPaidAction ? "Mark" : "Unmark"} {paidType === "gst" ? "GST" : "TDS"} as {isPaidAction ? "Paid" : "Unpaid"}
              </h2>
              <div className="mb-4 text-center">
                <p className="text-gray-600 mb-2">Selected Records: {selectedRows.size}</p>
                <p className={`text-2xl font-bold ${isPaidAction ? "text-green-600" : "text-red-600"}`}>
                  Total {paidType === "gst" ? "GST" : "TDS"}: ₹{" "}
                  {getSelectedTotal(paidType!).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </div>
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className={`rounded-md px-4 py-2 text-sm font-medium text-white border border-gray-200 focus:z-10 focus:ring-2 ${isPaidAction ? "bg-green-500 hover:bg-green-600 focus:ring-green-700" : "bg-red-500 hover:bg-red-600 focus:ring-red-700"}`}
                  onClick={handleConfirmPaid}
                  disabled={isBulkUpdating}
                >
                  {isBulkUpdating ? "Updating..." : "Confirm"}
                </button>
                <button
                  className="rounded-md px-4 py-2 text-sm font-medium text-white bg-gray-500 border border-gray-200 hover:bg-gray-600 focus:z-10 focus:ring-2 focus:ring-gray-700"
                  onClick={() => {
                    setGstTdsPaidModalOpen(false);
                    setPaidType(null);
                    setIsPaidAction(true);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bulk Disburse/Reject Confirmation Modal */}
      {bulkActionModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50 bg-black-900/50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-dark1 min-w-[350px]">
              <h2 className="text-lg font-semibold mb-4 text-center">
                Bulk {bulkActionType === "disburse" ? "Disburse" : "Reject"}
              </h2>
              <div className="mb-4 text-center">
                <p className="text-gray-600 mb-2">Selected Records: {selectedRows.size}</p>
                <p className={`text-2xl font-bold ${bulkActionType === "disburse" ? "text-green-600" : "text-red-600"}`}>
                  Total Payable: ₹{" "}
                  {tableData
                    .filter((row: any) => selectedRows.has(row.id))
                    .reduce((sum: number, row: any) => sum + (Number(row.finalAmount || 0) - Number(row.tds || 0)), 0)
                    .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p>
              </div>
              {bulkActionType === "reject" && (
                <div className="mb-4">
                  <label className="block mb-0.5 text-sm font-medium text-gray-900">Remark</label>
                  <input
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder="Reject Remark"
                    value={bulkRemark}
                    onChange={(e) => setBulkRemark(e.target.value)}
                  />
                </div>
              )}
              <div className="flex justify-center items-center gap-x-4">
                <button
                  className={`rounded-md px-4 py-2 text-sm font-medium text-white border border-gray-200 focus:z-10 focus:ring-2 ${
                    bulkActionType === "disburse"
                      ? "bg-green-500 hover:bg-green-600 focus:ring-green-700"
                      : "bg-red-500 hover:bg-red-600 focus:ring-red-700"
                  }`}
                  onClick={handleConfirmBulkAction}
                  disabled={isBulkUpdating}
                >
                  {isBulkUpdating ? "Updating..." : bulkActionType === "disburse" ? "Confirm Disburse" : "Confirm Reject"}
                </button>
                <button
                  className="rounded-md px-4 py-2 text-sm font-medium text-white bg-gray-500 border border-gray-200 hover:bg-gray-600 focus:z-10 focus:ring-2 focus:ring-gray-700"
                  onClick={() => {
                    setBulkActionModalOpen(false);
                    setBulkActionType(null);
                    setBulkRemark("");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header Section */}
      <div className="flex items-center justify-between px-4 mb-0 mt-1">
        {/* Left: GST & TDS Paid Buttons */}
        <div className="flex gap-2">
          <button
            onClick={() => handlePaidClick("gst", true)}
            type="button"
            className="bg-purple-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-purple-700 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            GST Paid
          </button>
          <button
            onClick={() => handlePaidClick("gst", false)}
            type="button"
            className="bg-purple-400 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-purple-500 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            GST Unpaid
          </button>
          <button
            onClick={() => handlePaidClick("tds", true)}
            type="button"
            className="bg-orange-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-orange-700 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            TDS Paid
          </button>
          <button
            onClick={() => handlePaidClick("tds", false)}
            type="button"
            className="bg-orange-400 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-orange-500 disabled:opacity-50"
            disabled={selectedRows.size === 0}
          >
            TDS Unpaid
          </button>
        </div>

        {/* Center: Title & Add New Button */}
        <div className="flex items-center gap-4">
          <h1 className="text-lg font-semibold">Vendor Payment</h1>
          <button
            onClick={() => {
              navigator("/master/vendorpayment/add");
            }}
            type="button"
            className="bg-green-700 text-white px-4 py-1 rounded-md"
          >
            Add New
          </button>
        </div>

        {/* Right: Export Buttons & TDS Report */}
        <div className="flex gap-2">
          <button onClick={exportToExcel} className="bg-blue-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-blue-700">
            Excel Export
          </button>
          <button
            onClick={exportTdsReport}
            className="bg-teal-600 text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-teal-700"
          >
            TDS Report
          </button>
        </div>
      </div>

      <div className="px-2 border-[1px] py-2 mx-2 mt-1 rounded-md">
        <div className="flex flex-col items-center">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-2">
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Vendor</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} min-w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={branchOptions}
                isMulti
                onChange={(e) => {
                  setBranchOtp(e ? [...e] : []);
                }}
                value={branchOpt}
                isClearable={true}
              />
            </div>
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Subbranch</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={subbranchOptions}
                onChange={(e) => {
                  setSelectedSubbranch(e);
                }}
                value={selectedSubbranch}
                isClearable={true}
              />
            </div>

            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Status</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-40 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={GenericColumnData?.vendorpayment?.tableColumnData?.find((d: any) => d.key === "status")?.options || []}
                onChange={(e) => {
                  setSelectedStatus(e);
                }}
                value={selectedStatus}
                isClearable={true}
              />
            </div>

            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">Bill No</label>
              <input
                type="text"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-28 p-2.5`}
                placeholder="Bill No"
                value={billNoFilter}
                onChange={(e) => setBillNoFilter(e.target.value)}
              />
            </div>
            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">Ref No</label>
              <input
                type="text"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-20 p-2.5`}
                placeholder="Ref No"
                value={ackNoFilter}
                onChange={(e) => setAckNoFilter(e.target.value)}
              />
            </div>

            <AfDateRangePicker setStartDate={setStartDate} setEndDate={setEndDate} label="Start - End Date" />
            <button
              type="button"
              onClick={__handleSubmit}
              className="ml-2 mt-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-green-600 focus:z-10 focus:ring-2 focus:ring-blue-700"
            >
              Search
            </button>
            <button
              type="button"
              onClick={__handleReset}
              className="ml-2 mt-2 rounded-md px-4 py-2 text-sm font-medium text-slate-700 bg-gray-200 border border-gray-300 hover:bg-gray-300 focus:z-10 focus:ring-2"
            >
              Reset
            </button>
          </div>
        </div>
      </div>

      <div className="px-4 border-[1px] py-2 mx-4 my-1 rounded-md text-center flex items-center justify-center gap-2 flex-wrap">
        {selectedRows.size > 0 &&
          !tableData.some(
            (row: any) => selectedRows.has(row.id) && ["PAID", "REJECTED", "PENDING"].includes(row.status),
          ) && (
            <div className="inline-flex gap-2 flex-col mr-8">
              <Button
                onPress={() => handleBulkAction("disburse")}
                color="success"
                size="sm"
              >
                Bulk Disburse ({selectedRows.size})
              </Button>
              <Button
                onPress={() => handleBulkAction("reject")}
                color="danger"
                size="sm"
              >
                Bulk Reject ({selectedRows.size})
              </Button>
              {userDetails.roleName == roles.SUPER_ADMIN && paymentPublicKey && (
                <Button
                  onPress={handleBulkPayment}
                  color="warning"
                  size="sm"
                  className="text-white"
                >
                  Bulk Payment ({selectedRows.size})
                </Button>
              )}
            </div>
          )}
        {selectedRows.size > 0 && (
          <div className="inline-flex gap-2 flex-col mr-8">
            <Button
              onPress={handlePaymentAdvice}
              color="primary"
              size="sm"
            >
              Payment Advice ({selectedRows.size})
            </Button>
          </div>
        )}
        {/* Summary Buttons: Independent of search filters (similar to Expense Voucher For Disburse) */}
        <div className="flex items-center gap-2 flex-wrap">
          <Button
            size="sm"
            color="secondary"
            variant="solid"
            className="h-8 text-xs font-semibold text-white bg-purple-600 hover:bg-purple-700 shadow-sm"
            onPress={() => setSummaryPopupType("VERIFIED")}
          >
            Verified ({verifiedTotalCount}) - ₹{verifiedTotalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Button>

          <Button
            size="sm"
            variant="solid"
            className="h-8 text-xs font-semibold text-white bg-orange-500 hover:bg-orange-600 shadow-sm"
            onPress={() => setSummaryPopupType("PROCESSED")}
          >
            Processed ({processedTotalCount}) - ₹{processedTotalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Button>

          {bankReturnTotalCount > 0 && (
            <Button
              size="sm"
              variant="solid"
              className="h-8 text-xs font-semibold text-white bg-red-600 hover:bg-red-700 shadow-sm"
              onPress={() => setSummaryPopupType("BANK_RETURN")}
            >
              Bank Return ({bankReturnTotalCount}) - ₹{bankReturnTotalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </Button>
          )}
        </div>

        {Object.keys(kpsTotal).map((kpsKeys) => {
          return (
            <div
              key={kpsKeys + "-kps"}
              className={`border-2 rounded-md p-2 inline-block cursor-pointer transition-all hover:opacity-90 ${kpsKeys == "PENDING" ? "bg-yellow-200" : ""} ${
                kpsKeys == "VERIFIED" ? "bg-purple-200" : ""
              } ${kpsKeys == "PAID" ? "bg-green-300" : ""}`}
              onClick={() => {
                if (kpsKeys === "VERIFIED") setSummaryPopupType("VERIFIED");
              }}
            >
              <p className="font-semibold">
                {kpsKeys || "-"} ({kpsTotal[kpsKeys][0]})
              </p>
              <p className="text-2xl">
                {"₹ " +
                  (Number(kpsTotal[kpsKeys][1]) || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </p>
            </div>
          );
        })}
      </div>

      <div className="px-4">
        <table className="w-full table- mb-8" style={{ fontSize: "85%" }} id="myTable" ref={tableRef}>
          <thead className="sticky top-0 bg-gray-300">
            <tr className="ignore-excel">
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1">{tableData?.length}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1" colSpan={5}>
                {selectedRows.size > 0 && (
                  <span className="text-primary font-inter">
                    Selected Payable: ₹{" "}
                    {tableData
                      .filter((row: any) => selectedRows.has(row.id))
                      .reduce((sum: number, row: any) => sum + (Number(row.finalAmount || 0) - Number(row.tds || 0)), 0)
                      .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    {" "}({selectedRows.size} rows)
                  </span>
                )}
              </th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1 py-2">{totals.base?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.cgst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.sgst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.igst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.grand).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.tds).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.payable).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.totalPaid).toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.remaining).toFixed(2)}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
            </tr>
            <tr>
              <th className="border border-slate-200 px-1">
                <input
                  type="checkbox"
                  checked={tableData?.length > 0 && selectedRows.size === tableData?.length}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                  className="w-4 h-4 cursor-pointer"
                />
              </th>
              <th className="border border-slate-200 px-1">Sr.</th>
              <th className="border border-slate-200 px-1">Action</th>
              <th className="border border-slate-200 px-1">Vendor</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Pay Date {GET_SORT_ICON("paymentDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Invoice Date {GET_SORT_ICON("invoiceDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">From Date {GET_SORT_ICON("fromDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">To Date {GET_SORT_ICON("toDate", "")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Recv Date {GET_SORT_ICON("recvDate", "")}</th>
              <th className="border border-slate-200 px-1">Bill No</th>
              <th className="border border-slate-200 px-1">Basic Amt</th>
              <th className="border border-slate-200 px-1">cgst</th>
              <th className="border border-slate-200 px-1">sgst</th>
              <th className="border border-slate-200 px-1">igst</th>
              <th className="border border-slate-200 px-1">Invoice Amt</th>
              <th className="border border-slate-200 px-1">tds</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Payable<br/>Amt {GET_SORT_ICON("payable", "")}</th>
              <th className="border border-slate-200 px-1">Total Paid</th>
              <th className="border border-slate-200 px-1">Remaining</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Status {GET_SORT_ICON("Status", "asc")}</th>
              <th className="border border-slate-200 px-1">Ref No</th>
              <th className="border border-slate-200 px-1">GST Paid</th>
              <th className="border border-slate-200 px-1">TDS Paid</th>
              <th className="border border-slate-200 px-1">-</th>
              <th className="border border-slate-200 px-1">Remark</th>
              <th className="border border-slate-200 px-1">File</th>
              <th className="border border-slate-200 px-1">Transactions</th>
              <th className="border border-slate-200 px-1">Ack No</th>
              <th className="border border-slate-200 px-1">Days</th>
              <th className="border border-slate-200 px-1">Vendor GST</th>
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((r, i) => {
                return (
                  <tr
                    key={"r" + r.id}
                    className={`${
                      r.refNo == "PROCESS"
                        ? "bg-orange-300"
                        : r.status == "PAID"
                          ? "bg-green-300"
                          : r.status == "REJECTED"
                            ? "bg-red-300"
                            : r.status == "PENDING"
                              ? "bg-yellow-200"
                              : r.status == "VERIFIED"
                                ? "bg-purple-200"
                                : ""
                    }`}
                  >
                    <td className="border border-slate-200 px-2">
                      <input
                        type="checkbox"
                        checked={selectedRows.has(r.id)}
                        onChange={(e) => handleRowSelect(r.id, e.target.checked)}
                        className="w-4 h-4 cursor-pointer"
                      />
                    </td>
                    <td className="border border-slate-200 px-2">{i + 1}</td>
                    <td className="border border-slate-200 px-2">
                      {userDetails.roleName != roles.SUPER_ADMIN && !["PAID", "REJECTED", "VERIFIED"].includes(r.status) && (
                        <button
                          onClick={() => {
                            Swal.fire({
                              title: "Are you sure!",
                              html: `${r._vendor.vendor_name}<br>Amount:${r.finalAmount}`,
                              icon: "question",
                              confirmButtonText: "Verify Invoice",
                              showCancelButton: true,
                            }).then((x) => {
                              if (x.isConfirmed) {
                                updatePayMutate({
                                  url: "/admin/vendorpayment/update/" + r?.id,
                                  data: {
                                    status: "VERIFIED",
                                  },
                                });
                              }
                            });
                          }}
                          className="text-white bg-purple-800 px-2 py-1 rounded-md mt-1"
                        >
                          Verify
                        </button>
                      )}
                      {userDetails.roleName == roles.SUPER_ADMIN && !["PAID", "REJECTED", "PENDING"].includes(r.status) && (
                        <button
                          onClick={() => {
                            //onStateChange("DISBURSED");
                            setDisburseModalOpen(true);
                            setSeletedPayment(r);
                          }}
                          className="text-white bg-green-600 px-1 py-0.5 text-sm rounded-md"
                        >
                          Disburse
                        </button>
                      )}
                      {!["PAID", "REJECTED"].includes(r.status) && (
                        <button
                          onClick={() => {
                            setRejectModalOpen(true);
                            setSeletedPayment(r);
                          }}
                          className="text-white bg-red-600 px-2 py-1 rounded-md mt-1"
                        >
                          Reject
                        </button>
                      )}
                    </td>
                    <td className="border border-slate-200 px-2">{r._vendor?.vendor_name}</td>
                    <td className="border border-slate-200 px-2">
                      {r.paymentDate != "Invalid Date" ? moment(r.paymentDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY") : "-"}
                    </td>
                    <td className="border border-slate-200 px-2">{moment(r.invoiceDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2">{moment(r.fromDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2">{moment(r.toDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2">{moment(r.recvDate, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2">{r.billNo}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.basicAmount}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.cgst}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.sgst}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.igst}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.finalAmount}</td>
                    <td className="border border-slate-200 px-2 text-right">{r.tds}</td>
                    <td className="border border-slate-200 px-2 text-right">{(r.finalAmount - r.tds).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2 text-right">{Number(r.totalPaid || 0).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2 text-right">{((Number(r.finalAmount) || 0) - (Number(r.tds) || 0) - (Number(r.totalPaid) || 0)).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2">{r.status}</td>
                    <td className="border border-slate-200 px-2">{r.refNo}</td>
                    <td
                      className={`border border-slate-200 px-2 text-center font-semibold ${Number(r.cgst || 0) + Number(r.sgst || 0) + Number(r.igst || 0) == 0 || r.gstPaid ? "bg-green-400 text-green-900" : "bg-red-200 text-red-800"}`}
                    >
                      {Number(r.cgst || 0) + Number(r.sgst || 0) + Number(r.igst || 0) == 0 ? "Yes" : r.gstPaid ? "Yes" : "No"}
                    </td>
                    <td
                      className={`border border-slate-200 px-2 text-center font-semibold ${r.tdsPaid ? "bg-green-400 text-green-900" : "bg-red-200 text-red-800"}`}
                    >
                      {r.tdsPaid ? "Yes" : "No"}
                    </td>
                    <td className="border border-slate-200 px-2">
                      <button
                        onClick={() => {
                          //navigator(`/master/vendorpayment/list/${r.id}`);
                          window.open(`/master/vendorpayment/list/${r.id}`, "_blank");
                        }}
                        className="text-blue-500"
                      >
                        View
                      </button>
                      <br />
                      <button
                        onClick={() => {
                          let confirm_ = window.confirm("Are you sure");
                          if (confirm_) {
                            deleteVendorPayment(r.id);
                          }
                          //navigator(`/master/vendorpayment/list/${r.id}`);
                        }}
                        className="text-red-500"
                      >
                        Delete
                      </button>
                    </td>
                    <td className="border border-slate-200 px-2">{r.remark}</td>
                    <td className="border border-slate-200 px-2">
                      {r.fileUrl ? (
                        (() => {
                          // Parse fileUrl format: invoiceUrl|ab1,ab2,ab3
                          const [invoiceUrl, airwaybillsStr] = r.fileUrl.includes("|") ? r.fileUrl.split("|") : [r.fileUrl, ""];
                          const airwaybills = airwaybillsStr ? airwaybillsStr.split(",").filter(Boolean) : [];
                          const isAwbDropdownOpen = openAwbDropdownId === r.id;

                          return (
                            <div className="flex flex-col gap-1 relative">
                              {invoiceUrl && (
                                <div className="flex items-center gap-1">
                                  <span className="text-xs text-gray-600">Inv:</span>
                                  <a
                                    href={invoiceUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                    className="text-blue-500 hover:text-blue-700 inline-block"
                                    title="Download Invoice"
                                  >
                                    <ArrowDownTrayIcon className="h-4 w-4" />
                                  </a>
                                </div>
                              )}
                              {airwaybills.length > 0 && (
                                <div className="flex items-center gap-1 relative">
                                  <span className="text-xs text-gray-600">AWB:</span>
                                  <button
                                    onClick={() => setOpenAwbDropdownId(isAwbDropdownOpen ? null : r.id)}
                                    className="flex items-center gap-1 px-2 py-0.5 bg-green-100 hover:bg-green-200 rounded text-xs text-green-700 font-semibold"
                                    title="View Airwaybill Files"
                                  >
                                    <ArrowDownTrayIcon className="h-3 w-3" />
                                    <span>{airwaybills.length}</span>
                                  </button>

                                  {isAwbDropdownOpen && (
                                    <>
                                      <div className="fixed inset-0 z-10" onClick={() => setOpenAwbDropdownId(null)}></div>
                                      <div className="absolute right-0 top-6 z-20 bg-white border border-gray-300 rounded-lg shadow-lg p-2 min-w-[180px] max-h-[300px] overflow-y-auto">
                                        <div className="text-xs font-semibold text-gray-700 mb-2 pb-2 border-b">
                                          Airwaybill Files ({airwaybills.length})
                                        </div>
                                        {airwaybills.map((url, idx) => (
                                          <a
                                            key={idx}
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                            className="flex items-center gap-2 px-2 py-1.5 hover:bg-gray-100 rounded text-xs text-gray-700 group"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <ArrowDownTrayIcon className="h-3.5 w-3.5 text-green-600 group-hover:text-green-700" />
                                            <span className="flex-1 truncate">AWB {idx + 1}</span>
                                          </a>
                                        ))}
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })()
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>
                    <td className="border border-slate-200 px-2 whitespace-nowrap">
                      {r.transactions && r.transactions.length > 0 ? (
                        <div className="flex flex-col gap-1">
                          {r.transactions.map((txn, idx) => (
                            <div key={idx} className={`flex flex-col font-inter ${idx < r.transactions.length - 1 ? "border-b border-gray-300 pb-1" : ""}`}>
                              <p>Pay Dt: <b>{txn.date ? moment(txn.date).format("DD-MM-YY") : "-"}</b></p>
                              <p>Utr: <b>{txn.utrNo || "-"}</b></p>
                              <p>Amt: <b>{txn.amount ? Number(txn.amount).toFixed(2) : "-"}</b></p>
                            </div>
                          ))}
                          
                        </div>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>
                    <td className="border border-slate-200 px-2">{r.id}</td>
                    <td className="border border-slate-200 px-2">
                      {r.status != "DISBURSED" && r.status != "PAID"
                        ? moment().diff(moment(r.recvDate, "DD-MM-YYYY HH:mm:ss"), "days")
                        : "-"}
                    </td>
                    <td className="border border-slate-200 px-2">{r._vendor?.gstno_client_supplier}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      {/* ═══════════ VENDOR SUMMARY POPUP (PENDING / VERIFIED / PROCESSED) ═══════════ */}
      {summaryPopupType && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-start justify-center z-[9999] pt-20"
          onClick={() => setSummaryPopupType(null)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl w-[540px] max-h-[75vh] overflow-hidden flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              className={`px-5 py-3 flex items-center justify-between ${
                summaryPopupType === "VERIFIED"
                  ? "bg-gradient-to-r from-purple-600 to-indigo-600"
                  : summaryPopupType === "BANK_RETURN"
                  ? "bg-gradient-to-r from-red-600 to-rose-700"
                  : "bg-gradient-to-r from-orange-500 to-amber-600"
              }`}
            >
              <div className="flex items-center gap-3">
                <h2 className="text-white font-bold text-sm tracking-wide">
                  {summaryPopupType === "VERIFIED"
                    ? "Verified Summary (Needs Payment)"
                    : summaryPopupType === "BANK_RETURN"
                    ? "Bank Return Summary"
                    : "Processed / In Process Summary"}
                </h2>
                {/* Switcher Tabs */}
                <div className="flex items-center bg-black/20 rounded-lg p-0.5 text-xs">
                  <button
                    type="button"
                    onClick={() => setSummaryPopupType("VERIFIED")}
                    className={`px-2.5 py-1 rounded-md font-semibold transition-all ${
                      summaryPopupType === "VERIFIED"
                        ? "bg-white text-slate-900 shadow-sm"
                        : "text-white/80 hover:text-white"
                    }`}
                  >
                    Verified ({verifiedTotalCount})
                  </button>
                  <button
                    type="button"
                    onClick={() => setSummaryPopupType("PROCESSED")}
                    className={`px-2.5 py-1 rounded-md font-semibold transition-all ${
                      summaryPopupType === "PROCESSED"
                        ? "bg-white text-slate-900 shadow-sm"
                        : "text-white/80 hover:text-white"
                    }`}
                  >
                    In Process ({processedTotalCount})
                  </button>
                  {bankReturnTotalCount > 0 && (
                    <button
                      type="button"
                      onClick={() => setSummaryPopupType("BANK_RETURN")}
                      className={`px-2.5 py-1 rounded-md font-semibold transition-all ${
                        summaryPopupType === "BANK_RETURN"
                          ? "bg-white text-red-700 shadow-sm"
                          : "text-white/80 hover:text-white"
                      }`}
                    >
                      Bank Return ({bankReturnTotalCount})
                    </button>
                  )}
                </div>
              </div>
              <button
                className="text-white/80 hover:text-white text-xl font-bold leading-none cursor-pointer"
                onClick={() => setSummaryPopupType(null)}
              >
                ×
              </button>
            </div>

            {/* Table Content */}
            <div className="overflow-y-auto max-h-[55vh] p-4">
              {isSummaryLoading ? (
                <div className="py-12 text-center text-slate-400 text-sm">Loading summary...</div>
              ) : activeSummaryEntries.length === 0 ? (
                <div className="py-12 text-center text-slate-400 text-sm">
                  No {summaryPopupType.toLowerCase().replace("_", " ")} records found
                </div>
              ) : (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-slate-200">
                      <th className="text-left py-2 px-2 text-[11px] font-semibold text-slate-600 uppercase">Vendor Name</th>
                      <th className="text-center py-2 px-2 text-[11px] font-semibold text-slate-600 uppercase">Count</th>
                      <th className="text-right py-2 px-2 text-[11px] font-semibold text-slate-600 uppercase">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeSummaryEntries.map(([key, item]: [string, any]) => (
                      <tr key={key} className="border-b border-slate-100 hover:bg-slate-50">
                        <td className="py-2 px-2 text-[13px] text-slate-700 font-medium">
                          {item.name}
                        </td>
                        <td className="py-2 px-2 text-[13px] text-slate-700 text-center font-mono">{item.count}</td>
                        <td className="py-2 px-2 text-[13px] font-semibold text-slate-800 text-right font-mono">
                          ₹{item.payableAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="border-t-2 border-slate-300 bg-slate-50 font-bold">
                      <td className="py-2 px-2 text-[13px] text-slate-900">Total</td>
                      <td className="py-2 px-2 text-[13px] text-slate-900 text-center font-mono">
                        {activeSummaryTotalCount}
                      </td>
                      <td className="py-2 px-2 text-[13px] text-slate-900 text-right font-mono">
                        ₹{activeSummaryTotalAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>

            {/* Footer */}
            <div className="px-5 py-3 border-t border-slate-200 flex justify-end">
              <Button
                size="sm"
                color="default"
                variant="flat"
                className="h-7 text-xs font-semibold"
                onPress={() => setSummaryPopupType(null)}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VendorPayList;
